/* camera.icon.svg.js */

module.exports = {
    icon: `    
            <svg viewBox="0 0 21 16" preserveAspectRatio="none">
            <g>
                <ellipse class="foreground-gl" cx="10.5" cy="9.4" rx="3.3" ry="3.2"/>
                <path class="foreground-gl" d="M19.6,2.8h-2.4c-0.8,0-1.4-0.6-1.4-1.4S15.1,0,14.3,0H6.7C5.9,0,5.3,0.6,5.3,1.4S4.6,2.8,3.8,2.8H1.4
                    C0.6,2.8,0,3.5,0,4.2v10.4C0,15.4,0.6,16,1.4,16h18.1c0.8,0,1.4-0.6,1.4-1.4V4.2C21,3.5,20.4,2.8,19.6,2.8z M2.1,5.6
                    c-0.5,0-1-0.4-1-0.9s0.4-0.9,1-0.9c0.5,0,1,0.4,1,0.9S2.6,5.6,2.1,5.6z M10.5,14.6c-2.9,0-5.3-2.3-5.3-5.2c0-2.9,2.4-5.2,5.3-5.2
                    c2.9,0,5.3,2.3,5.3,5.2C15.8,12.3,13.4,14.6,10.5,14.6z"/>
            </g>
            </svg>
         `
};
